import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { store } from 'components/Store';
import { locationTopicDescriptor } from 'components/Dashboard/helpers/locationSearchDescriptor';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import { useSetListsIds } from 'components/Dashboard/MainSearchBar/setListIds';

const useResearchItemsUrl = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { keywordsLists, modifiedListId, memoryMasterTopic } = state;

  const location = useLocation();
  const { getStoredListIds } = useSetListsIds();

  const storedLists = getStoredListIds({});
  let localStorageId;
  if (!!storedLists) {
    localStorageId = storedLists?.[0];
  }
  const stakeholdersFirstList = keywordsLists?.find((item) =>
    modifiedListId ? item.id === modifiedListId : localStorageId ? item.id === localStorageId : item.id !== null
  );

  const firstList = keywordsLists?.[0];
  const stakeholderTopicParam =
    getUrlParam('topic-id') && getUrlParam('topic-id') !== 'all'
      ? `?topic-id=${getUrlParam('topic-id')}`
      : stakeholdersFirstList
        ? `?topic-id=${stakeholdersFirstList.id}`
        : '';

  const createMonitorUrl = () => {
    const viewParam = getUrlParam('view');
    const viewSuffix = viewParam ? `&view=${viewParam}` : '';
    let search;
    if (memoryMasterTopic && keywordsLists?.length > 1) {
      search = `?topic-id=all${viewSuffix}`;
    } else {
      search = `${
        locationTopicDescriptor(location) !== '' && getUrlParam('topic-id') !== 'none'
          ? locationTopicDescriptor(location)
          : `${firstList ? `?topic-id=${firstList.id === null ? 'all' : firstList.id}${viewSuffix}` : ''}`
      }`;
    }
    return `/monitor-inbox${search}`;
  };

  const monitorUrl = createMonitorUrl();
  const stakeholderUrl = `/people/stakeholder-mapping${stakeholderTopicParam}`;
  const policymakerUrl = `/policymakers${stakeholderTopicParam}`;

  return { stakeholderUrl, policymakerUrl, stakeholderTopicParam, monitorUrl };
};

export default useResearchItemsUrl;
